(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["listicle-before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-lst-ba]').forEach(function (sec) {
        if (sec.__lstInit) return;
        sec.__lstInit = true;
        var range = sec.querySelector('[data-lst-ba-range]');
        if (!range) return;
        var set = function () { sec.style.setProperty('--lst-ba-pos', range.value + '%'); };
        range.addEventListener('input', set);
        set();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["listicle-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Listicle: Carousel — arrows and dots for a scroll-snap track. Swiping is
    // native scrolling; this keeps the dots in step and wires the buttons.
    // Stacked layouts hide the controls in CSS, so the script is harmless there.
    function setup(root) {
      if (root.dataset.lstReady) return;
      root.dataset.lstReady = '1';
      var track = root.querySelector('.lst-car__track');
      var slides = root.querySelectorAll('[data-car-slide]');
      var dots = root.querySelectorAll('[data-car-dot]');
      var n = slides.length;
      if (!track || n < 2) return;
      function current() {
        return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;
      }
      var target = -1;
      function mark(i) {
        Array.prototype.forEach.call(dots, function (dot, d) {
          var on = d === i;
          dot.classList.toggle('is-active', on);
          if (on) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        });
      }
      function go(i) {
        i = (i % n + n) % n;
        target = i;
        mark(i);
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      }
      function sync() {
        var i = current();
        // while an arrow / dot scroll is still travelling, keep its dot lit
        if (target > -1 && i !== target) return;
        target = -1;
        mark(i);
      }
      track.addEventListener('scroll', sync, { passive: true });
      // a swipe by hand cancels a pending arrow target
      track.addEventListener('touchstart', function () { target = -1; }, { passive: true });
      var prev = root.querySelector('[data-car-prev]');
      var next = root.querySelector('[data-car-next]');
      if (prev) prev.addEventListener('click', function () { go(current() - 1); });
      if (next) next.addEventListener('click', function () { go(current() + 1); });
      Array.prototype.forEach.call(dots, function (dot) {
        dot.addEventListener('click', function () { go(parseInt(dot.getAttribute('data-car-dot'), 10)); });
      });
      // theme editor: selecting a slide block scrolls to it
      root.addEventListener('shopify:block:select', function (e) {
        var i = Array.prototype.indexOf.call(slides, e.target);
        if (i > -1) go(i);
      });
      sync();
    }
    function init(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-lst-carousel]'), setup);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["listicle-double-feature"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function clamp1(v) { return v > 1 ? 1 : (v < -1 ? -1 : v); }

    // 1 while the element is still below the fold, 0 once it has scrolled past.
    function travel(rect) {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var center = rect.top + rect.height / 2;
      var p = (center - vh / 2) / (vh / 2 + rect.height / 2);
      return (clamp1(p) + 1) / 2;
    }

    function num(v, fallback) { var n = parseFloat(v); return isNaN(n) ? fallback : n; }

    function setup(root) {
      if (root.dataset.dfReady) return;
      root.dataset.dfReady = '1';

      var reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      var mobileMq = window.matchMedia ? window.matchMedia('(max-width: 640px)') : null;
      var updaters = [];

      // Framed photo: Zoom / position are CSS variables (set by Liquid, switched
      // by the stylesheet at <= 640px); the script only adds the parallax.
      Array.prototype.forEach.call(root.querySelectorAll('[data-df-frame]'), function (frame) {
        var par = num(frame.dataset.dfPar, 0);
        updaters.push(function (fixed) {
          var r = frame.getBoundingClientRect();
          if (!r.height) return;
          var t = fixed ? 0.5 : travel(r);
          frame.style.setProperty('--df-py', (par / 100 * r.height * (t - 0.5)).toFixed(1) + 'px');
        });
      });

      // Blob photo: the SVG <image> box is computed from the data attributes for
      // the current breakpoint, and the parallax moves its y.
      Array.prototype.forEach.call(root.querySelectorAll('[data-df-blob]'), function (svg) {
        var img = svg.querySelector('image');
        if (!img) return;
        var vb = (svg.getAttribute('viewBox') || '0 0 622 449').split(/\s+/).map(parseFloat);
        var VW = vb[2] || 622, VH = vb[3] || 449;
        var d = svg.dataset;
        var par = num(d.dfPar, 0);
        var wrap = svg.closest('[data-df-blob-wrap]') || svg.parentElement || svg;
        updaters.push(function (fixed) {
          var m = mobileMq && mobileMq.matches;
          var z = num(m ? d.dfZm : d.dfZ, 100);
          var px = num(m ? d.dfXm : d.dfX, 0);
          var py = num(m ? d.dfYm : d.dfY, 0);
          var w = VW * z / 100, h = VH * z / 100;
          var x0 = (VW - w) / 2 + px / 100 * VW;
          var y0 = (VH - h) / 2 + py / 100 * VH;
          var t = fixed ? 0.5 : travel(wrap.getBoundingClientRect());
          img.setAttribute('width', w.toFixed(1));
          img.setAttribute('height', h.toFixed(1));
          img.setAttribute('x', x0.toFixed(1));
          img.setAttribute('y', (y0 + par / 100 * VH * (t - 0.5)).toFixed(1));
        });
      });

      if (!updaters.length) return;

      var ticking = false;
      function runAll() {
        for (var i = 0; i < updaters.length; i++) updaters[i](reduced);
        ticking = false;
      }
      function onScroll() {
        if (!ticking) { ticking = true; window.requestAnimationFrame(runAll); }
      }

      runAll();                 // place the photos once, always
      if (reduced) {
        // Reduce Motion: the photos stay put, but still follow breakpoint changes.
        window.addEventListener('resize', onScroll, { passive: true });
        return;
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }

    function init(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-lst-dblfeat]'), setup);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["listicle-feature-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Listicle: Feature gallery — port of the Replo section-2 gallery script
    // (v2.0, looping). Both tracks are overflow: hidden; the script animates
    // their scrollLeft together, so text and image always move as one.
    function setup(root) {
      if (root.dataset.fgReady) return;
      root.dataset.fgReady = '1';

      var imageTrack = root.querySelector('[data-fg-image-track]');
      var textTrack = root.querySelector('[data-fg-text-track]');
      var images = Array.prototype.slice.call(root.querySelectorAll('[data-fg-image]'));
      var texts = Array.prototype.slice.call(root.querySelectorAll('[data-fg-text]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-fg-dot]'));
      var prevBtn = root.querySelector('[data-fg-prev]');
      var nextBtn = root.querySelector('[data-fg-next]');
      if (!imageTrack || !images.length) return;
      if (textTrack && texts.length !== images.length) textTrack = null;

      var count = images.length;
      var DURATION_DESKTOP = parseInt(root.dataset.fgDuration, 10);
      var DURATION_MOBILE = parseInt(root.dataset.fgDurationM, 10);
      if (isNaN(DURATION_DESKTOP)) DURATION_DESKTOP = 80;
      if (isNaN(DURATION_MOBILE)) DURATION_MOBILE = 50;
      var loop = root.dataset.fgLoop !== 'false';
      var swipeOn = root.dataset.fgSwipe !== 'false';
      var wheelOn = root.dataset.fgWheel !== 'false';
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var index = 0;
      var animating = false;
      var animRaf = null;

      function isDesktop() { return window.innerWidth > 1024; }
      function duration() {
        if (reduceMotion) return 0;
        return isDesktop() ? DURATION_DESKTOP : DURATION_MOBILE;
      }
      // loop: wrap the index into [0, count-1]; otherwise clamp to the ends
      function place(i) {
        if (loop) return ((i % count) + count) % count;
        return Math.max(0, Math.min(count - 1, i));
      }

      // only the script moves the tracks: no native scroll, no snapping
      [imageTrack, textTrack].forEach(function (tr) {
        if (!tr) return;
        tr.style.setProperty('overflow', 'hidden', 'important');
        tr.style.setProperty('overflow-x', 'hidden', 'important');
        tr.style.scrollSnapType = 'none';
        tr.style.touchAction = 'pan-y'; // vertical page scroll allowed; we handle horizontal
      });

      function updateDots() {
        dots.forEach(function (dot, n) {
          var on = n === index;
          dot.classList.toggle('is-active', on);
          if (on) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        });
      }
      function updateArrows() {
        if (loop) {
          // no ends, so the arrows are always live
          [prevBtn, nextBtn].forEach(function (b) { if (b) b.disabled = false; });
          return;
        }
        if (prevBtn) prevBtn.disabled = index === 0;
        if (nextBtn) nextBtn.disabled = index === count - 1;
      }

      // slide i's left edge inside its track, relative to slide 0
      function targetLeft(slides, i) {
        var slide = slides[i];
        if (!slide) return null;
        return slide.offsetLeft - (slides[0] ? slides[0].offsetLeft : 0);
      }

      // dur: optional override (the touch release); default is the slide time
      function animateBoth(i, dur) {
        if (animRaf) cancelAnimationFrame(animRaf);
        animating = true;

        var imgFrom = imageTrack.scrollLeft;
        var imgTo = targetLeft(images, i);
        var txtFrom = textTrack ? textTrack.scrollLeft : 0;
        var txtTo = textTrack ? targetLeft(texts, i) : 0;

        if (dur == null) dur = duration();
        if (reduceMotion) dur = 0;
        var start = performance.now();
        var ease = function (t) { return 1 - Math.pow(1 - t, 3); };

        function finish() {
          animRaf = null;
          if (imgTo != null) imageTrack.scrollLeft = imgTo;
          if (textTrack && txtTo != null) textTrack.scrollLeft = txtTo;
          animating = false;
        }
        if (dur <= 0) { finish(); return; }

        function frame(now) {
          var t = Math.min(1, (now - start) / dur);
          var e = ease(t);
          if (imgTo != null) imageTrack.scrollLeft = imgFrom + (imgTo - imgFrom) * e;
          if (textTrack && txtTo != null) textTrack.scrollLeft = txtFrom + (txtTo - txtFrom) * e;
          if (t < 1) animRaf = requestAnimationFrame(frame); else finish();
        }
        animRaf = requestAnimationFrame(frame);
      }

      // every input ends here, so the dots can never drift from the slide shown
      function goTo(i, allowSame, dur) {
        var c = place(i);
        if (c === index && !animating && !allowSame) return;
        index = c;
        updateDots();
        updateArrows();
        animateBoth(index, dur);
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i); });
      });

      // ---- WHEEL / TRACKPAD (desktop): a horizontal gesture = one slide ----
      var wheelCooldown = false, wheelAccum = 0;
      function onWheel(e) {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return; // vertical → let the page scroll
        e.preventDefault();
        if (animating || wheelCooldown) return;
        wheelAccum += e.deltaX;
        if (Math.abs(wheelAccum) > 30) {
          goTo(index + (wheelAccum > 0 ? 1 : -1));
          wheelAccum = 0;
          wheelCooldown = true;
          setTimeout(function () { wheelCooldown = false; }, duration() + 80);
        }
      }

      // ---- TOUCH / PEN SWIPE: the tracks follow the finger, then glide ----
      var startX = 0, startY = 0, tracking = false, decided = false, horizontal = false;
      var THRESH = 40;       // px moved that counts as a swipe
      var FLICK = 0.3;       // px/ms: a quick flick counts too, however short
      var SWIPE_MS = 280;    // release glide for a full slide
      var imgBase = 0, txtBase = 0, imgStep = 1, txtStep = 1, lastX = 0, lastT = 0, velocity = 0;

      // distance from one slide to the next in a track (slide width + gap)
      function step(slides) {
        if (slides.length > 1) return slides[1].offsetLeft - slides[0].offsetLeft;
        return slides[0] ? slides[0].offsetWidth : 1;
      }
      function releaseMs(fraction) {
        if (reduceMotion) return 0;
        var full = Math.max(SWIPE_MS, duration());
        return Math.max(120, Math.round(full * Math.min(1, Math.abs(fraction))));
      }
      function down(e) {
        if (e.pointerType === 'mouse') return; // desktop uses the wheel, not drag
        startX = lastX = e.clientX; startY = e.clientY; lastT = e.timeStamp; velocity = 0;
        tracking = true; decided = false; horizontal = false;
      }
      function startDrag(e) {
        // grab the slide where it is, even mid-glide
        if (animRaf) { cancelAnimationFrame(animRaf); animRaf = null; }
        animating = false;
        imgBase = imageTrack.scrollLeft;
        txtBase = textTrack ? textTrack.scrollLeft : 0;
        imgStep = step(images) || 1;
        txtStep = textTrack ? (step(texts) || 1) : 1;
        try { e.currentTarget.setPointerCapture(e.pointerId); } catch (err) { /* already released */ }
      }
      // scrollLeft cannot go past the first or last slide, so the ends simply stop
      function dragTo(dx) {
        var p = -dx / imgStep; // slides moved, + = towards the next
        imageTrack.scrollLeft = imgBase + p * imgStep;
        if (textTrack) textTrack.scrollLeft = txtBase + p * txtStep;
      }
      function move(e) {
        if (!tracking) return;
        var dx = e.clientX - startX, dy = e.clientY - startY;
        if (!decided && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
          decided = true;
          horizontal = Math.abs(dx) > Math.abs(dy);
          if (horizontal) startDrag(e);
          else { tracking = false; return; } // vertical: leave it to the page
        }
        if (!decided || !horizontal) return;
        if (e.cancelable) e.preventDefault();
        var dt = e.timeStamp - lastT;
        if (dt > 0) velocity = 0.8 * ((e.clientX - lastX) / dt) + 0.2 * velocity;
        lastX = e.clientX; lastT = e.timeStamp;
        dragTo(dx);
      }
      function up(e) {
        if (!tracking) return;
        tracking = false;
        if (!horizontal) return;
        var dx = e.clientX - startX;
        if (e.timeStamp - lastT > 100) velocity = 0; // finger rested before lifting
        var dir = 0;
        if (Math.abs(dx) > THRESH || Math.abs(velocity) > FLICK) dir = (dx || -velocity) < 0 ? 1 : -1;
        var target = index + dir;
        // without loop, swiping past an end just springs back
        if (!loop && (target < 0 || target > count - 1)) { target = index; dir = 0; }
        // share of a slide still to travel; looping past an end crosses every slide
        var left = (dx + dir * imgStep) / imgStep;
        if (place(target) !== target) left = 1;
        goTo(target, dir === 0, releaseMs(left));
      }
      function cancel() {
        if (!tracking) return;
        tracking = false;
        if (horizontal) goTo(index, true, releaseMs(0.5));
      }

      [imageTrack, textTrack].forEach(function (tr) {
        if (!tr) return;
        if (wheelOn) tr.addEventListener('wheel', onWheel, { passive: false });
        if (swipeOn) {
          tr.addEventListener('pointerdown', down);
          tr.addEventListener('pointermove', move, { passive: false });
          tr.addEventListener('pointerup', up);
          tr.addEventListener('pointercancel', cancel);
        }
      });

      // breakpoint / width change: re-snap to the current slide
      var rt = null;
      window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(function () { updateDots(); updateArrows(); animateBoth(index); }, 150);
      });

      // theme editor: selecting a slide block slides to it
      root.addEventListener('shopify:block:select', function (e) {
        var i = images.indexOf(e.target);
        if (i > -1) goTo(i, true);
      });

      // parallax: drift every slide's picture inside the frame as the page scrolls
      var parallax = parseFloat(root.dataset.fgParallax);
      if (root.classList.contains('lst-fg--parallax') && !reduceMotion && parallax > 0) {
        var pRaf = null;
        var parallaxFrame = function () {
          pRaf = null;
          var r = imageTrack.getBoundingClientRect();
          var vh = window.innerHeight || document.documentElement.clientHeight;
          if (!r.height || r.bottom < 0 || r.top > vh) return;
          var progress = ((r.top + r.height / 2) - vh / 2) / ((vh + r.height) / 2);
          if (progress > 1) progress = 1; else if (progress < -1) progress = -1;
          var shift = -progress * r.height * parallax / 100;
          imageTrack.style.setProperty('--fg-py', shift.toFixed(1) + 'px');
        };
        var onScroll = function () { if (pRaf === null) pRaf = requestAnimationFrame(parallaxFrame); };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        onScroll();
      }

      goTo(0, true);
    }

    function init(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-lst-gallery]'), setup);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["listicle-single-review"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Listicle: Reviews — rotate the cards: 1 visible on mobile, up to 3 on desktop.
    // A click shifts every card toward the clicked arrow; the card on that side
    // is hidden and the next one comes in on the other side.
    var DESKTOP = '(min-width: 990px)';
    function setup(stage) {
      if (stage.dataset.lstReady) return;
      stage.dataset.lstReady = '1';
      var cards = Array.prototype.slice.call(stage.querySelectorAll('.lst-sr__card'));
      var n = cards.length;
      var start = 0;
      var mq = window.matchMedia(DESKTOP);
      // Same card size whatever is showing: unless a fixed height is set for
      // this width, every card gets the height of the tallest review (measured
      // with all of them laid out at the visible card width).
      function equalize() {
        var fixed = parseInt(stage.getAttribute(mq.matches ? 'data-card-h' : 'data-card-h-m'), 10) || 0;
        stage.style.removeProperty('--lst-sr-card-auto-h');
        if (fixed > 0 || n < 2) return;
        var shown = cards.filter(function (c) { return !c.hidden; })[0] || cards[0];
        var w = shown.getBoundingClientRect().width;
        if (!w) return;
        stage.style.setProperty('--lst-sr-measure-w', w + 'px');
        stage.classList.add('is-measuring');
        var tallest = 0;
        cards.forEach(function (c) { tallest = Math.max(tallest, c.getBoundingClientRect().height); });
        stage.classList.remove('is-measuring');
        if (tallest) stage.style.setProperty('--lst-sr-card-auto-h', Math.ceil(tallest) + 'px');
      }
      function layout() {
        var per = mq.matches ? Math.min(3, n) : 1;
        cards.forEach(function (card, i) {
          var pos = (i - start + n) % n;
          card.style.order = pos;
          card.hidden = pos >= per;
        });
        stage.style.setProperty('--lst-sr-per', Math.min(3, n));
        stage.classList.toggle('has-nav', n > per);
        stage.classList.add('is-ready');
      }
      var resizeTimer = 0;
      function remeasureSoon() {
        // measure after the layout settles (a breakpoint switch can report a mid-transition width)
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(equalize, 150);
      }
      function relayout() { layout(); equalize(); remeasureSoon(); }
      var prev = stage.querySelector('.lst-sr__arrow--prev');
      var next = stage.querySelector('.lst-sr__arrow--next');
      if (prev) prev.addEventListener('click', function () { start = (start + 1) % n; layout(); });
      if (next) next.addEventListener('click', function () { start = (start - 1 + n) % n; layout(); });
      if (mq.addEventListener) mq.addEventListener('change', relayout); else if (mq.addListener) mq.addListener(relayout);
      window.addEventListener('resize', remeasureSoon);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(equalize);
      relayout();
    }
    function init(root) {
      Array.prototype.forEach.call((root || document).querySelectorAll('[data-lst-reviews]'), setup);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
